import { udpApi } from 'yxt-biz-pc/packages/api';

// 获取机构扩展字段
export const getExtSpars = () => {
  return udpApi.get('orgs/usermgr/spares?spareRegionType=3');
};
